"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes = require("prop-types");

var Dot = _styledComponents.default.li.attrs({
  // eslint-disable-next-line react/prop-types
  children: function children(_ref) {
    var onClick = _ref.onClick;
    return /*#__PURE__*/_react.default.createElement("button", {
      onClick: onClick,
      type: "button"
    }, "\u2022");
  } // eslint-disable-line react/prop-types

}).withConfig({
  displayName: "Dot",
  componentId: "sc-1vi9qra-0"
})(["display:inline-block;pointer-events:none;button{pointer-events:all;border:0;background:0 0;cursor:pointer;font-size:1.8em;line-height:1.2em;margin:0 5px;", ":hover{color:#000000;}:focus{outline:none;}}"], function (_ref2) {
  var active = _ref2.active;
  return active ? 'color: #000000;' : 'color: #E5E5E5;';
});

Dot.propTypes = {
  onClick: _propTypes.func
};
var _default = Dot;
exports.default = _default;